import { Path } from '@/main/router/routerPath';

import List from './List.vue';
import { NAME, CRUMB_LABEL_KEY } from './constants';

export const router = new Path(NAME, { List }, CRUMB_LABEL_KEY);
